module.exports = __webpack_public_path__ + "static/img/31-北京邮电大学附属小学(今典校区)1.eb11a99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/31-北京邮电大学附属小学(今典校区)1.png
// module id = VXIb
// module chunks = 0